// client/src/routes/app/expenses/recurring.tsx — SCR-EXP-003 · EXP-005 phase 2 (04 §8.7).
//
// The route D-715 refused to stub — „a placeholder advertises work that is late rather than
// deferred" — now that the six rule routes and the preview are in the contract (D-870–D-878).
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed. `Expenses.Read`, as the list endpoint is (D-870); the
// builder and the stop inside the screen are behind `Expenses.Write`.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { RecurringRulesScreen } from '@/features/expenses/RecurringRules';
import { recurringSearchSchema, type RecurringSearch } from '@/features/expenses/recurring-search';

export const Route = createFileRoute('/app/expenses/recurring')({
  validateSearch: recurringSearchSchema,
  component: RecurringScreen,
});

function RecurringScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Expenses.Read">
      <RecurringRulesScreen
        search={search}
        onSearchChange={(next: (previous: RecurringSearch) => RecurringSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
